<template lang="pug">
.conversation-reviews-list
  template(v-if="reviewsList.length")
    .review-item(v-for="review in reviewsList" :key="review.id" @click="openReviewDialog({ review })")
      .row
        .title {{ $t(`${translationBasePath}.reviewer_name`) }}
        .detail {{ review.reviewer.fullName }}
      .row
        .title {{ $t(`${translationBasePath}.reviewe_date`) }}
        .detail {{ formatDate(review.updated_at) }}
  .no-reviews(v-else) No Reviews for this customer yet
</template>

<script>
import { mapState, mapActions } from 'vuex';
import dayjs from '@/localPlugins/dayjs';

export default {
  name: 'ConversationReviewsList',
  computed: {
    ...mapState({
      reviewsList: state => state.conversationReviews.reviewsList,
    }),
    translationBasePath() {
      return 'conversation_tab.side_panel.convseration_reviews_accordion';
    },
  },
  methods: {
    ...mapActions({
      openReviewDialog: 'conversationReviews/openDialog',
    }),
    formatDate(date) {
      return dayjs(date).format('MM/DD/YYYY');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../../../../styles/aiq-variables.scss";

.conversation-reviews-list {
  padding: 5px 16px;
  font-size: 0.75rem;
  font-weight: 200;

  .review-item {
    font-size: 0.75rem;
    margin-bottom: 12px;
    border-radius: 4px;
    box-shadow: 0 0 3px 0 #bfcbd9;
    background-color: #fff;
    cursor: pointer;
    padding: 5px 10px;

    &:hover {
      box-shadow: 0 0 3px 2px #bfcbd9;
    }

    .row {
      display: flex;

      > * {
        flex: 1;
      }

      .title {
        font-weight: 300;
      }
    }
  }
}
</style>
